export const FILE_NAME_LENGTH_ERROR_MESSAGE = 'Вы пытаетесь загрузить файл с длинным именем, сократите название и попробуйте снова';
export const FILES_COUNT_ERROR_MESSAGE = 'Количество файлов превышает допустимое ограничение';
export const FILES_SIZE_ERROR_MESSAGE = 'Размер файлов превышает допустимое ограничение';